import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Report } from 'src/api'
import { useApiInstance } from './useApiInstance'

export interface RegenerateReportVariables {
  reportId: number;
  // Only valid for combined reports — regenerates a single subreport, then rebuilds the root archive.
  subreportId?: number;
}

interface RegenerateReportRequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error | null, RegenerateReportVariables, Report>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useRegenerateReportRequest = ({
  options,
}: RegenerateReportRequestParams = {}) => {
  const api = useApiInstance()
  return useMutation(
    ({ reportId, subreportId }: RegenerateReportVariables) =>
      api.v1AdminReportsReportIdRegeneratePost(reportId, subreportId !== undefined ? { subreportId } : undefined),
    options,
  )
}
